<template>
    <div class="omocom-basic-insurance" :class="modifiers">
        <div class="omocom-basic-insurance__wrapper">
            <p class="omocom-basic-insurance__title">{{ $t('pages.booking_request.insurance_step.omocom_basic') }}</p>
            <svg-icon v-if="isTypeSuccess" name="check" />
        </div>
        <p class="omocom-basic-insurance__description">
            <template v-if="showOwnerInfo">
                {{ $t('pages.booking_request.insurance_step.omocom_owner_basic_description') }}
            </template>
            <template v-else>
                {{
                    $t('pages.booking_request.insurance_step.omocom_basic_description', {
                        deductible: deductibleFormattedPrice,
                    })
                }}
            </template>
        </p>

        <strong v-if="isTypeInfo">{{ $t('pages.booking_request.included_in_price') }}</strong>

        <div class="omocom-basic-insurance__see-details">
            <a @click="seeDetails">
                {{ $t('common.see_details') }}
            </a>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { actionTypes as modalActions } from '~/store/modal';
import { actionTypes as slideUpModalActions } from '~/store/slideUpModal';

export default {
    name: 'OmocomBasicInsuranceNotice',
    props: {
        type: {
            type: String,
            default: '',
            validator: value => ['', 'info', 'success'].includes(value),
        },
        product: {
            type: Object,
            required: true,
        },
        isInteriorInsuranceIncluded: {
            type: Boolean,
            default: false,
        },
        useSlideUpModal: {
            type: Boolean,
            default: false,
        },
        showOwnerInfo: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters(['isLargeScreen', 'isOwner']),
        modifiers() {
            return {
                'omocom-basic-insurance--info': this.isTypeInfo,
                'omocom-basic-insurance--success': this.isTypeSuccess,
            };
        },
        isTypeSuccess() {
            return this.type === 'success';
        },
        isTypeInfo() {
            return this.type === 'info';
        },
        deductibleFormattedPrice() {
            const amount = this.product?.specifications?.deductibleAmount;

            return amount ? this.formattedPrice(amount, this.product.currency) : 0;
        },
    },
    methods: {
        seeDetails() {
            const data = {
                product: this.product,
                isInteriorInsuranceIncluded: this.isInteriorInsuranceIncluded,
                showOwnerInfo: this.showOwnerInfo,
            };

            if (!this.isLargeScreen && this.useSlideUpModal) {
                this.displayOmocomInsuranceProtectionDetailsSlideUpModal(data);
            } else {
                this.displayOmocomInsuranceProtectionDetailsModal(data);
            }
        },
        async displayOmocomInsuranceProtectionDetailsModal(data) {
            try {
                return await this.$store.dispatch(modalActions.MODAL_OPEN, {
                    component: 'OmocomInsuranceProtectionDetailsModal',
                    style: { lesserPadding: true },
                    data,
                });
            } catch (err) {}
        },
        async displayOmocomInsuranceProtectionDetailsSlideUpModal(data) {
            try {
                return await this.$store.dispatch(slideUpModalActions.SLIDEUP_MODAL_OPEN, {
                    component: 'OmocomInsuranceProtectionDetailsModal',
                    data,
                });
            } catch (err) {}
        },
    },
};
</script>

<style scoped lang="scss">
@import '@/sass/_variables.scss';

.omocom-basic-insurance {
    border-radius: $default-border-radius;
    border: 1px solid $border-color;
    padding: 16px;

    &__wrapper {
        display: flex;
        justify-content: space-between;
    }

    .svg-icon {
        width: 24px;
        height: 24px;
        min-width: 24px;
        margin-left: 16px;
        color: $blue-dark;
    }

    &__title {
        font-weight: 600;
    }

    &__description {
        @include font-size(14px);
    }

    &__see-details {
        margin-top: 24px;
        text-align: right;
        color: $primary;
    }

    &--info {
        background-color: $neutral-97;
        border: none;
    }

    &--success {
        background-color: $bright-blue-light;
        border: none;
    }
}
</style>
